import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import {Outlet, useNavigate} from "react-router-dom";
import AppHeader from "./components/AppHeader";
import AppSidebar from "./components/AppSidebar";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {useEffect, useState} from "react";
import {connect} from "trim-redux";
import clsx from "clsx";
import AppFooter from "./components/footer/AppFooter";
import ErrorPage from "../../pages/errors/ErrorPage";
import {isSupplier, isUnSignedSupplier} from "../../../config/Permissions";
import SignContractDialog from "../elements/SignContractDialog";
import CharityBanner from "../../pages/front/main/charities/CharityBanner";

function Layout({classes,user,isAuth,panel,front,error}) {
    const navigate = useNavigate();
    const redirect = localStorage.getItem('redirect');
    const [forCharity, setForCharity] = useState(!!localStorage.getItem('charity_slug'));
    const from_app = !!localStorage.getItem('from_app');
    useEffect(() => {
        if (isAuth) {
            if(!user?.first_name){
                navigate('/user-info')
            }
            if(!!redirect){
                localStorage.removeItem('redirect');
                navigate(redirect)
            }
        }
    }, [user,isAuth ]);

    const handleCloseCharityBanner = () => {
        localStorage.removeItem("charity_slug");
        localStorage.removeItem("charity_name");
        setForCharity(false);
        window.location.reload();
    };
    return (
        <React.Fragment>
            {
                !!error ?
                    <ErrorPage error={error}/>
                    :
                    <>
                        <CssBaseline />
                        {
                            !from_app &&
                            <AppHeader panel={panel}/>
                        }

                        <main className={classes.layoutMain}>
                            {
                                (!!panel && !from_app) &&
                                <AppSidebar/>
                            }

                            <div className={clsx(classes.layoutHolder,!!from_app ? "app-layout" : !!panel ? "panel-layout" : !!front ? 'front-layout' : 'normal-layout')}>
                                {
                                    (!!panel && !!isUnSignedSupplier()) && <SignContractDialog/>
                                }
                                {

                                    front ?
                                        <Outlet/>
                                        :
                                        <Container maxWidth="lg" >
                                            <Outlet/>
                                        </Container>
                                }
                            </div>
                        </main>
                        {
                            (!panel && !from_app) &&
                            <AppFooter />
                        }
                        {forCharity && <CharityBanner onClose={handleCloseCharityBanner} />}

                    </>
            }
        </React.Fragment>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    error: state.error,
});

export default withStyles(Styles)(connect(mapStateToProps)(Layout));
